import type { AnyValue } from "@/lib/rowTypes";
/**
 * Global FCI / Financial Confidence System exclusion.
 * Apply to every query, in-memory list, and chart dataset on the Parent Intelligence Hub.
 */
export const FCI_TERMS = [
  "Financial Confidence System",
  "FCI",
  "Financial Confidence",
  "Confidence Index",
  "Confidence Score",
  "Confidence Grade",
] as const;

export function isFciTopic(topic?: string | null): boolean {
  if (!topic) return false;
  const t = topic.toLowerCase();
  return FCI_TERMS.some((term) => t.includes(term.toLowerCase()));
}

/**
 * Apply FCI exclusion to a Supabase PostgrestFilterBuilder on the given column.
 * Returns the same builder so it can be chained.
 */
export function applyFciFilter<T>(query: T, column = "topic"): T {
  const q = query as AnyValue;
  return q
    .neq(column, "Financial Confidence System")
    .not(column, "ilike", "%FCI%")
    .not(column, "ilike", "%Financial Confidence%")
    .not(column, "ilike", "%Confidence Index%")
    .not(column, "ilike", "%Confidence Score%")
    .not(column, "ilike", "%Confidence Grade%");
}